import { useState } from 'react';
// import { Link } from 'react-router-dom';
import Slider, { Settings } from 'react-slick';
import ImageContainer from '../../components/ui/ImageContainer';
// import ImageContainer from '../../components/ui/ImageContainer';
import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { INews } from '../../types';
import { NewsBN, NewsEN } from '../../utils';
import { getLocaleString } from '../../utils/locales';
import './styles.css';

function News() {
  const locale = getData(LANGUAGE);
  const data = locale === 'en' ? NewsEN : NewsBN
  const [, setIsPrevShow] = useState(false);
  const settings: Settings = {
    
    dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 5000,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
    dotsClass: 'button__bar',
    beforeChange: (next: any) => {
      if (next > 0) {
        setIsPrevShow(true);
      } else {
        setIsPrevShow(false);
      }
    },
  };

  return (
    // <div className="w-full flex items-center justify-center lg:flex lg:space-x-5">
<div className='space-y-5'>
      <p className="text-center text-xl lg:text-3xl font-bold text-[#010103]/80">
            {getLocaleString('gold_kinen_news', locale)}
          </p>
      <div className="my-5">
        <Slider {...settings} >
          {data.map((item: INews, key: number): any => {
            return (
              <div key={key} className="my-5">
               <a href={item.link} target="_blank" rel="noreferrer">
                <ImageContainer src={item.image} alt={item.image} className="h-[100px] lg:h-[250px] flex justify-center border border-none" />
                <p className='underline flex items-center justify-center text:lg lg:text-xl my-5'>{item.title}</p></a> 
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}

export default News;
